import { render, staticRenderFns } from "./joinus.vue?vue&type=template&id=242a3f8d&scoped=true"
import script from "./joinus.vue?vue&type=script&lang=js"
export * from "./joinus.vue?vue&type=script&lang=js"
import style0 from "./joinus.vue?vue&type=style&index=0&id=242a3f8d&prod&lang=scss&scoped=true"
import style1 from "./joinus.vue?vue&type=style&index=1&id=242a3f8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a3f8d",
  null
  
)

export default component.exports